import {ActorFilterProvider} from './actor-filter-provider'
import {singleValueFilterTypes} from './shared-filter-types'
import type {User as ActorUser} from '@github-ui/user-selector'

export class UserFilterProvider extends ActorFilterProvider {
  constructor(actors: ActorUser[] = []) {
    super(
      {
        displayName: 'User',
        key: 'user',
        description: 'Specify the user',
        actors,
      },
      {
        filterTypes: singleValueFilterTypes,
      },
    )
  }
}
